import * as React from 'react';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import { withStyles } from '../../settings/styles';
import { connect } from 'react-redux';
import { AppState } from '../../model/reducers';
import { ThunkDispatch } from 'redux-thunk';
import { loadingOverlay, broadcastMessage } from '../../model/overlay/actions';
import { BroadcastType } from '../../model/overlay/types';
import { PictureAsPdf } from '@mui/icons-material';
import { NavigationTabProps } from '../../model/navigation/types';



// ----------------- State & Props -----------------  //

interface State 
{

};

interface StateProps
{

}

interface DispatchProps
{
    loading: ()=>void;
    doneLoading: ()=>void;
    broadcast: (msg: string, type?: BroadcastType) => void;
}

type Props = NavigationTabProps & StateProps & DispatchProps;

// -------------------- Class --------------------  //

class MyExtensions extends React.Component<Props, State> 
{
    // ============================================ //
    //               Member Variables               //
    // ============================================ //

    translation: any;

    // ============================================ //
    //               Routine Functions              //
    // ============================================ //

    constructor(props: any)
    {
        super(props);

        // Init State
        this.state = {

        };

        // Setup Member Functions
        
    }

    render()
    {
        const { t } = this.props;
        return (<>
            <Box sx={{ maxWidth: 936, margin: 'auto', overflow: 'hidden' }}>
                <Typography sx={{marginBottom: "30px", fontSize: 18, fontWeight: 5}}>
                    Qlik Sense Extensions
                </Typography>
            </Box>
            <Paper sx={{ maxWidth: 936, margin: 'auto', height: 55, overflow: 'hidden' }}>
                <Grid container columns={10} sx={{padding: 0}}>
                    <Grid item xs={7}>
                        <Typography sx={{margin: 2}}>
                            <PictureAsPdf sx={{verticalAlign: 'middle', mr: 1, pb: "3px"}} />
                            Invoice PDF Viewer
                        </Typography>
                    </Grid>
                    <Grid item xs={3} sx={{textAlign: "end"}}>
                        <a href="./extensions/invoice-pdf-viewer-ext.zip">
                            <Button sx={{margin: 1}} color="secondary">{t('general.download')}</Button>
                        </a>
                    </Grid>
                </Grid>
            </Paper>
        </>);
    }

    // ============================================ //
}

// ----------------- Export -----------------  //

const mapStateToProps = (state: AppState, props: NavigationTabProps): StateProps => ({

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{},{},any>, props: NavigationTabProps): DispatchProps => ({
    loading: ()=>dispatch(loadingOverlay(true)),
    doneLoading: ()=>dispatch(loadingOverlay(false)),
    broadcast: (msg, type?)=>dispatch(broadcastMessage(msg, type))
});

export default withStyles(connect(mapStateToProps, mapDispatchToProps)(MyExtensions));

// ------------------------------------------  //